<!--<div class="overlay" *ngIf="visibility"></div>-->
<div class="sidenav animate-bottom" *ngIf="visibility">
  <button (click)="closeSideNav()">Fechar</button>
  <ul>
    <li><a (click)="closeSideNav()" [routerLink]="['/management']" >Gerenciar Áreas</a></li>
  </ul>  
</div>
